import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <Path
            fill={ds.colorValue.icon.brand}
            d="M16.212 2.132c.447.007.846.022 1.2.05.722.06 1.343.183 1.915.474a4.878 4.878 0 0 1 2.13 2.131l.102.217c.22.512.32 1.067.372 1.697.058.711.058 1.594.058 2.7v5.313c0 1.105 0 1.988-.058 2.7-.051.63-.152 1.185-.372 1.696l-.101.217a4.877 4.877 0 0 1-1.961 2.04l-.17.091c-.572.291-1.193.415-1.914.474-.711.058-1.594.057-2.7.057H9.4c-1.105 0-1.988 0-2.7-.057-.63-.052-1.185-.153-1.696-.372l-.217-.102a4.877 4.877 0 0 1-2.131-2.13c-.291-.572-.415-1.194-.474-1.915a18.62 18.62 0 0 1-.05-1.201l-.007-1.498V9.4c0-1.105 0-1.988.057-2.699.06-.72.183-1.342.474-1.914a4.877 4.877 0 0 1 2.13-2.13c.572-.292 1.194-.415 1.915-.474.71-.058 1.594-.058 2.7-.058h5.313l1.498.007Zm.378 5.574a.875.875 0 0 0-1.217.222l-4.48 6.48-2.129-2.325-.063-.063a.876.876 0 0 0-1.284 1.176l.056.069 2.87 3.134a.875.875 0 0 0 1.366-.092l5.103-7.383a.876.876 0 0 0-.222-1.218Z"
        />
    </Svg>
);
export default SvgComponent;
